export function generateUsername(
    firstName: string,
    lastName: string,
    existingUsernames: string[] = [],
): { username: string; warning?: string } {
    const cleanFirstName = firstName.toLowerCase().replace(/[^a-z]/g, '');
    const cleanLastName = lastName.toLowerCase().replace(/[^a-z]/g, '');

    let baseUsername = `${cleanFirstName[0]}${cleanLastName}`;
    if (!existingUsernames.includes(baseUsername)) {
        return { username: baseUsername };
    }

    if (cleanFirstName.length >= 2) {
        baseUsername = `${cleanFirstName.slice(0, 2)}${cleanLastName}`;
        if (!existingUsernames.includes(baseUsername)) {
            return { username: baseUsername };
        }
    }

    if (cleanFirstName.length >= 3) {
        baseUsername = `${cleanFirstName.slice(0, 3)}${cleanLastName}`;
        if (!existingUsernames.includes(baseUsername)) {
            return {
                username: baseUsername,
                warning: `Please check if the user with this name and surname already exists.`,
            };
        }
    }

    let counter = 1;
    let username = `${baseUsername}${counter}`;
    while (existingUsernames.includes(username)) {
        counter += 1;
        username = `${baseUsername}${counter}`;
    }

    return {
        username,
    };
}
